/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Legal_Entity_TitleInputs */

const cs_auth_signup_legal_entity_title = /** @type {(inputs: Auth_Signup_Legal_Entity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO / právní subjekt (nepovinné)`)
};

const en_auth_signup_legal_entity_title = /** @type {(inputs: Auth_Signup_Legal_Entity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal entity / IČO (optional)`)
};

/**
* | output |
* | --- |
* | "Legal entity / IČO (optional)" |
*
* @param {Auth_Signup_Legal_Entity_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_legal_entity_title = /** @type {((inputs?: Auth_Signup_Legal_Entity_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Legal_Entity_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_legal_entity_title(inputs)
	return cs_auth_signup_legal_entity_title(inputs)
});